import { Injectable } from '@angular/core';

@Injectable()
export class TrackModalService {
  private isModalOpen: boolean;
  private isConfirmModalOpen: boolean;

  constructor(
  ) {
    this.isModalOpen = false;
    this.isConfirmModalOpen = false;
  }

  public setModalOpen(open = true) {
    this.isModalOpen = open;
  }

  public setConfirmOpen(open = true) {
    this.isConfirmModalOpen = open;
  }

  public getConfirmOpen() {
    return this.isConfirmModalOpen;
  }

  public getModalOpen() {
    return this.isModalOpen;
  }
}
